import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

/**
 *
 *
 *
 *
 */
export function shouldShowWishlistIcon(onex: OnEx): boolean {
    return !onex.isExperimentGroup('WISHLIST_ELEMENT', 'E3803A');
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function wishlistQualified(multipleSizes: boolean | undefined): 'true' | 'false' {
    return multipleSizes ? 'false' : 'true';
}
